export default __webpack_public_path__ + "static/media/vasco.813d5085.png";